import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Paths that should never be tracked (admin pages)
const IGNORED_PREFIXES = ['/admin'];

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname || '/';
    if (IGNORED_PREFIXES.some((p) => path.startsWith(p))) return;

    // Fire and forget – never block UI on analytics
    axios
      .post(`${API}/analytics/track`, {
        path,
        referrer: document.referrer || '',
      })
      .catch(() => {
        /* silent */
      });
  }, [location.pathname]);

  return null;
};

export default PageTracker;
